import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InputType } from 'dg-input-lib';
import { DgPostSearchComponent } from 'dg-post-search-lib';
import { BulkReassignService } from './bulk-reassign.service';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import { of, zip } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-bulk-reassign',
  templateUrl: './bulk-reassign.component.html',
  styleUrls: ['./bulk-reassign.component.scss'],
})
export class BulkReassignComponent implements OnInit {
  rows = [];
  cols = [];
  selectedGrp = null;
  selectedUnit = null;
  grpCombo = null;
  empList = [];
  pageSize = 5;
  startIndex = 1;
  totalRecord = null;
  searchVal = '';
  reassignTo = '1';
  finalEmpList = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<BulkReassignComponent>,
    private bulkReassignService: BulkReassignService
  ) {}
  ngAfterViewInit(): void {
    let postData = { ComboId: '20004' };
    this.bulkReassignService.getComboData(postData).subscribe((res) => {
      this.grpCombo = res?.data;
    });
    if (this.data?.defaultAssignToValue) {
      this.reassignTo = this.data?.defaultAssignToValue;
    }
    if (this.data?.defaultSelectedGrp) {
      this.selectedGrp = this.data?.defaultSelectedGrp;
    }
    if (this.reassignTo == '1') {
      this.getEmployeeList();
    } else {
      this.onGrpChange();
    }
  }

  getEmployeeList(): void {
    if (this.reassignTo == '1' || !this.selectedGrp) {
      let params = new HttpParams()
        .set('nameValue', this.searchVal)
        .set('orgId', '')
        .set('startIndex', this.startIndex)
        .set('rowsPerPage', this.pageSize)
        .set('strRoleGrpIds', '')
        .set('dsgnId', '')
        .set('addressNumbers', '');

      this.bulkReassignService
        .getEmployeeList(params)
        ?.subscribe((res: any) => {
          res?.data?.forEach((ele) => {
            ele.wlRoleId = ele?.UNIT_ID;
          });
          this.totalRecord = res?.data?.[0]?.TOTAL_RECORDS;
          this.empList = res?.data;
          this.finalEmpList = res?.data;
        });
    }
  }

  onReassignToChange(): void {
    if (this.reassignTo === '1') {
      this.selectedUnit = null;
    }
  }

  onGrpChange(): void {
    this.searchVal = '';
    this.selectedUnit = null;
    if (this.selectedGrp?.toString()?.length > 0) {
      this.bulkReassignService
        ?.getAllMappedEmployees(this.selectedGrp)
        ?.subscribe((res) => {
          let data = [];
          res?.data?.forEach((ele) => {
            ele.UNIT_NAME = ele?.unitName;
            ele.FULL_NAME = ele?.empName;
            ele.ORG_NAME = ele?.orgName;
            ele.EMAIL_ID = ele?.empEmailId;
            ele.DSGN_NAME = ele?.dsgnName;
            ele.ORG_SHRT_NAME = ele?.orgShrtName;

            if (this.data?.removeSelectedUnitsFrmGrpList) {
              if (this.data?.selectedUnits?.length > 0) {
                let index = this.data?.selectedUnits?.findIndex(
                  (x) =>
                    x?.optionValue?.toString()?.trim() ===
                    ele?.empId?.toString()?.trim()
                );
                if (index == -1) {
                  data.push(ele);
                }
              } else {
                data.push(ele);
              }
            } else {
              data.push(ele);
            }
          });
          this.empList = data;
          this.finalEmpList = this.empList;
          this.totalRecord = data?.length;
        });
    } else {
      this.getEmployeeList();
    }
  }

  selectionChange(event): void {
    this.selectedUnit = event?.value;
  }

  onPageChange(event: any) {
    this.startIndex = event?.pageIndex + 1;
    this.pageSize = event?.pageSize;
    this.getEmployeeList();
  }

  onKeyUp(): void {
    if (!this.selectedGrp) {
      this.getEmployeeList();
    } else {
      if (this.searchVal?.length > 0) {
        this.empList = [];
        this.finalEmpList?.forEach((ele: any) => {
          if (
            ele?.FULL_NAME?.toString()
              ?.trim()
              ?.toLowerCase()
              ?.includes(this.searchVal?.toString()?.trim()?.toLowerCase())
          ) {
            this.empList.push(ele);
          }
        });
      } else {
        this.empList = [...this.finalEmpList];
      }
    }
  }

  ngOnInit(): void {}

  onSend(): void {
    let refIds = [];

    this.data?.selectedData?.forEach((ele) => {
      refIds.push(Number(ele?.docId));
    });

    let postData = {
      refId: refIds,
      applTypeId: 1,
      toUnit: [
        this.selectedUnit?.wlRoleId
          ? Number(this.selectedUnit?.wlRoleId)
          : Number(this.selectedGrp),
      ],
      toMpgType: Number(this.selectedUnit?.wlRoleId) ? [656] : [658],
      toGrpId: Number(this.selectedGrp),
      toType: Number(this.selectedUnit?.wlRoleId) ? null : 1970,
      movmentActionFlag: this.data?.isFromGrpWorklist ? 21 : null,
    };

    this.bulkReassignService?.reassignCase(postData)?.subscribe((res: any) => {
      this.dialogRef.close(true);
    });
  }

  isSendDisabled(): boolean {
    switch (this.reassignTo) {
      case '1':
        return !this.selectedGrp;
      case '2':
        return !this.selectedUnit;
    }
    return true;
  }
}
